import React from "react";

function NoMatch() {
  return <div>Page not found</div>;
}

export default NoMatch;
